import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    Stack,
    styled,
    Typography,
} from "@mui/material";
import TabsUnstyled from "@mui/base/TabsUnstyled";

export const FormContainerStack = styled(TabsUnstyled)({
    margin: "0 12px",
});

export const TabsStyled = styled(TabsUnstyled)({
    width: "100%",
    height: "100%",
    padding: "8px 0",
});

export const FormInputStack = styled(Stack)({
    cursor: "pointer",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "start",
    height: "fit-content",
    gap: "8px",
    span: {
        fontSize: "14px",
        fontWeight: "500",
    },
    svg: {
        width: "24px",
        height: "24px",
    },
});

export const CommentTextOutlinedInput = styled("textarea")({
    width: "100%",
    fontSize: "14px",
    resize: "none",
    padding: "8px",
    border: "1px solid var(--community-color-transparent-black-05)",
    color: "var(--community-color-primary-text)",
    borderRadius: "8px",
    outline: "none",
    boxSizing: "border-box",
    "::placeholder": {
        color: "var(--community-placeholder-color)",
    },
    ":focus": {
        outline: "none",
        border: "1px solid var(--community-color-dark-gray)",
    },
    "&._error": {
        borderColor: "var(--community-color-error-red)",
    },
});

export const FormImageInputStack = styled(Stack)({
    cursor: "pointer",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "space-between",
    height: "100%",
    input: {
        display: "none",
    },
    span: {
        fontSize: "14px",
        fontWeight: "500",
    },
    svg: {
        fontSize: "inherit",
        width: "24px",
        height: "24px",
    },
});

export const InputsContainer = styled(Box)({
    marginRight: "0",
    marginLeft: "0",
    display: "flex",
    flexDirection: "row",
    gap: "8px",
});

export const ImagesFormControlLabel = styled(FormControlLabel)({
    cursor: "pointer",
    display: "inline-flex",
    height: "fit-content",
    margin: "0",
    span: {
        fontWeight: "700",
        fontSize: "16px",
    },
});

export const SubmitButton = styled(Button)({
    borderRadius: "90px",
    background:
        "linear-gradient(to right bottom, #50739d, #6272a3, #786fa6, #8f6ba3, #a4669c)",
    "&.Mui-disabled": {
        background: "var(--community-color-transparent-black-05)",
    },
    padding: 0,
    width: "36px",
    maxWidth: "36px",
    minWidth: "36px",
    height: "36px",
    svg: {
        width: "20px",
        height: "20px",
        marginRight: "-5px",
        cursor: "pointer",
        fill: "var(--community-color-snow-white)",
    },
});

export const ModalActionsSubmitStack = styled(Stack)({
    gap: "16px",
    flexDirection: "row",
    alignItems: "start",
    flexWrap: "wrap",
});

export const LoadingStack = styled(Stack)({
    margin: "0 16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});
export const ErrorContainer = styled(Typography)({
    color: "var(--community-color-error-red)",
    fontSize: "0.75rem",
    lineHeight: "1.66",
    marginTop: "8px",
    textAlign: "left",
});

export const OptionsContainer = styled(Stack)({
    flexDirection: "row",
});

export const OptionsIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "activeBackgroundColor",
})<{ activeBackgroundColor?: string }>(({ activeBackgroundColor }) => ({
    width: "36px",
    height: "36px",
    backgroundColor:
        activeBackgroundColor ?? "var(--community-color-transparent-black-05)",
    svg: {
        width: "20px",
        height: "20px",
    },
}));

export const CommentReplyTextContainerGrid = styled(Grid)({
    flexDirection: "column",
    lineHeight: "1.25",
    justifyContent: "center",
    textAlign: "left",
    flexGrow: "1",
    marginBottom: "8px",
});

export const CommentReplyUserNameTypography = styled(Typography)({
    fontSize: "12px",
    color: "var(--community-color-secondary-text)",
});

export const CommentReplyTextParagraph = styled(Box)({
    fontSize: "12px",
    color: "var(--community-color-primary-text)",
    display: "flex",
});
